module.exports = __webpack_public_path__ + "static/media/leverage_group.05d0970a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/client_logo/leverage_group.jpg
// module id = 95
// module chunks = 0